module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Platina.91a46535.jpg";